import React from 'react';
import ContactInfoWidget from '../Widget/ContactInfoWidget';
import MenuWidget from '../Widget/MenuWidget';
import SocialWidget from '../Widget/SocialWidget';
import Newsletter from '../Widget/Newsletter';
import TextWidget from '../Widget/TextWidget';
const menuDataOne = [
  { title: 'Home', href: '/' },
  { title: 'About Us', href: '/about' },
  { title: 'Services', href: '/services' },
  { title: 'Contact Us', href: '/contact' },
  { title: 'Blogs', href: '/blog' },

];
const menuDataTwo = [
  { title: 'Privacy Policy', href: 'https://www.termsfeed.com/live/61f0a80f-3083-4606-90cd-c7e24f60c89f' },
  { title: 'Terms & Conditions', href: 'https://www.termsfeed.com/live/8b3ae86d-cb31-4b1a-a9ad-2732c323a8cd' },
];

export default function Footer() {
  return (
    <footer className="cs_footer cs_style_1 cs_heading_color" style={{ backgroundImage: 'url(/images/real/footer_bg.png)' }}>
      <div className="cs_footer_main">
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              <div className="cs_footer_item">
                <TextWidget text="BRR Diagnostics &<br />Diagnostic Center" />
                {/* <img src="/images/real/footer_logo.png" width="160px" alt="img" /> */}
                <ContactInfoWidget />
              </div>
            </div>
            <div className="col-lg-2">
              <div className="cs_footer_item">
                <MenuWidget data={menuDataOne} />
              </div>
            </div>
            <div className="col-lg-2">
              <div className="cs_footer_item">
                <MenuWidget data={menuDataTwo} />
              </div>
            </div>
            
            <div className="col-lg-4">
              <div className="cs_footer_item">
                <Newsletter
                  title="Be Our Subscribers"
                  subTitle="To get the latest news about health from our experts"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="cs_footer_bottom cs_accent_bg">
        <div className="container">
          <div className="cs_footer_bottom_in">
            <SocialWidget />
            <div className="cs_copyright">
              Copyright © 2026 BRR Diagnostics. All rights reserved.
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
